/**
 * WatermillMessagesListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * WatermillMessagesListReq
 */
export interface WatermillMessagesListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** Topic名称 */
  topic: string
  /** 消费者组名称（用于判断消费状态） */
  consumer_group?: string
  /** 是否已被消费（需要指定 consumer_group） */
  consumed?: boolean
  /** 消息UUID */
  uuid?: string
  /** 最小偏移量 */
  offset__gte?: number
  /** 最大偏移量 */
  offset__lte?: number
  /** 创建时间范围 */
  created_at__range?: any
}

/**
 * WatermillMessagesListReq Schema
 */
export const WatermillMessagesListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    topic: {
      description: 'Topic名称',
      format: 'string',
      type: 'string',
      label: 'Topic名称',
    },
    consumer_group: {
      description: '消费者组名称（用于判断消费状态）',
      format: 'string',
      type: 'string',
      label: '消费者组名称',
    },
    consumed: {
      description: '是否已被消费（需要指定 consumer_group）',
      format: '*bool',
      type: 'boolean',
      label: '是否已被消费',
    },
    uuid: {
      description: '消息UUID',
      format: 'string',
      type: 'string',
      label: '消息UUID',
    },
    offset__gte: {
      description: '最小偏移量',
      format: '*int64',
      type: 'integer',
      label: '最小偏移量',
    },
    offset__lte: {
      description: '最大偏移量',
      format: '*int64',
      type: 'integer',
      label: '最大偏移量',
    },
    created_at__range: {
      description: '创建时间范围',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
  },
  required: ['topic'],
  type: 'object',
}
